export default "__VITE_ASSET__CpJO701L__"